// v3
document.addEventListener('DOMContentLoaded', function () {

  // ── Qty selector interaction ──
  document.querySelectorAll('.qty-option').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.qty-option').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  // ── See More reviews toggle ──
  function toggleReviews() {
    const extra = document.getElementById('reviews-extra');
    const btn = document.getElementById('see-more-btn');
    const isOpen = extra.classList.contains('visible');
    if (isOpen) {
      extra.classList.remove('visible');
      btn.classList.remove('open');
      btn.innerHTML = 'See More Feedback <span class="arrow">↓</span>';
    } else {
      extra.classList.add('visible');
      btn.classList.add('open');
      btn.innerHTML = 'Show Less <span class="arrow">↓</span>';
    }
  }

  // ── Scroll fade-in for cards ──
  const observer = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.style.opacity = '1';
        e.target.style.transform = 'translateY(0)';
      }
    });
  }, { threshold: 0.08 });

  document.querySelectorAll('.step-card, .testimonial-card, .usecase-card, .bundle-card, .science-stat, .guarantee-item').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 0.55s ease, transform 0.55s ease';
    observer.observe(el);
  });

  // ── Reserved-visitor check ──
  // Shared with pinkies-floating.liquid via the same localStorage key. Once
  // someone has reserved, the sticky "Reserve Yours" pill should never
  // reappear, on this pageview or any future one.
  var PINKIES_RESERVED_KEY = 'pinkies_reserved';
  function pinkiesHasReserved() {
    try {
      return localStorage.getItem(PINKIES_RESERVED_KEY) === 'true';
    } catch (e) {
      return false;
    }
  }

  // ── Floating bar logic ──
  const waitlistBar = document.getElementById('waitlist-bar');
  const stickyAtc = document.getElementById('sticky-atc');
  const backToTop = document.getElementById('back-to-top');
  const heroSection = document.querySelector('.hero');
  let waitlistDismissed = pinkiesHasReserved();
  let waitlistTimer = null;

  if (pinkiesHasReserved() && stickyAtc) {
    stickyAtc.classList.remove('visible');
    stickyAtc.style.display = 'none';
  }

  waitlistTimer = setTimeout(() => {
    if (!waitlistDismissed) {
      waitlistBar.classList.add('visible');
    }
  }, 4000);

  function closeWaitlist() {
    waitlistDismissed = true;
    waitlistBar.classList.remove('visible');
    clearTimeout(waitlistTimer);
    setTimeout(() => {
      const hint = document.getElementById('waitlist');
      if (hint) hint.style.outline = '2px solid rgba(192,40,78,0.4)';
      setTimeout(() => { if (hint) hint.style.outline = ''; }, 1200);
    }, 300);
  }

  // ── Sticky ATC ──
  const heroObserver = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (pinkiesHasReserved()) {
        // Visitor already reserved — the sticky pill stays hidden regardless
        // of scroll position.
        if (stickyAtc) {
          stickyAtc.classList.remove('visible');
          stickyAtc.style.display = 'none';
        }
        return;
      }
      if (!e.isIntersecting) {
        stickyAtc.classList.add('visible');
        waitlistBar.classList.remove('visible');
      } else {
        stickyAtc.classList.remove('visible');
        if (!waitlistDismissed) {
          setTimeout(() => waitlistBar.classList.add('visible'), 600);
        }
      }
    });
  }, { threshold: 0 });

  if (heroSection) heroObserver.observe(heroSection);

  // ── Back to top ──
  window.addEventListener('scroll', () => {
    backToTop.classList.toggle('visible', window.scrollY > 400);
  });

  // ══════════════════════════════════════════════
  // PINKIES RESERVE NOW MODAL — Klaviyo Integration
  // List ID: S9ehHR | Company ID: ShuJPk
  // ══════════════════════════════════════════════

  var KLAVIYO_LIST_ID    = 'S9ehHR';
  var KLAVIYO_COMPANY_ID = 'ShuJPk';

  var overlay    = document.getElementById('pinkies-modal-overlay');
  var closeBtn   = document.getElementById('pinkies-modal-close');
  var emailInput = document.getElementById('pinkies-modal-email');
  var submitBtn  = document.getElementById('pinkies-modal-submit');
  var formWrap   = document.getElementById('pinkies-modal-form-wrap');
  var successEl  = document.getElementById('pinkies-modal-success');
  var errorEl    = document.getElementById('pinkies-modal-error');

  function openModal() {
    if (!overlay) return;
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { emailInput && emailInput.focus(); }, 100);
  }

  function closeModal() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  // Wire all Reserve Now buttons
  document.querySelectorAll(
    '.pinkies-reserve-btn, [data-action="reserve"], a[href="#reserve"], button[data-reserve]'
  ).forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openModal();
    });
  });

  // Close on overlay background click
  overlay && overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeModal();
  });

  // Close on X
  closeBtn && closeBtn.addEventListener('click', closeModal);

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  // Submit to Klaviyo
  submitBtn && submitBtn.addEventListener('click', function () {
    var email = emailInput.value.trim();

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errorEl.textContent = 'Please enter a valid email address.';
      errorEl.style.display = 'block';
      return;
    }

    errorEl.style.display = 'none';
    submitBtn.disabled = true;
    submitBtn.textContent = 'Reserving…';

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-02-15'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Reserve Now Modal',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: {
                    source: 'reserve_now_modal',
                    founding_offer: true,
                    discount: '20_percent'
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: KLAVIYO_LIST_ID
              }
            }
          }
        }
      })
    })
    .then(function (res) {
      if (res.ok || res.status === 202) {
        try { localStorage.setItem(PINKIES_RESERVED_KEY, 'true'); } catch (e) {}
        if (stickyAtc) {
          stickyAtc.classList.remove('visible');
          stickyAtc.style.display = 'none';
        }
        formWrap.style.display = 'none';
        successEl.style.display = 'block';
        errorEl.style.display = 'none';
      } else {
        return res.text().then(function(body) {
          console.error('Klaviyo error:', res.status, body);
          throw new Error('Klaviyo error ' + res.status);
        });
      }
    })
    .catch(function (err) {
      console.error('Pinkies modal error:', err);
      errorEl.textContent = 'Something went wrong. Please try again.';
      errorEl.style.display = 'block';
      submitBtn.disabled = false;
      submitBtn.textContent = 'Reserve My Spot';
    });
  });

}); // end DOMContentLoaded